// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 230) return "dist/js/ckeditor.js";
	if (chunkId === 736) return "dist/js/chartjs.js";
	if (chunkId === 520) return "dist/js/fullcalendar-roster.js";
	if (chunkId === 851) return "dist/js/tour.js";
	if (chunkId === 875) return "dist/js/sortable.js";
	if (chunkId === 888) return "dist/js/fullcalendar-planner.js";
	// return url for filenames based on template
	return undefined;
};